<div class="nav-slot" [blazeSlotNode]="slots?.slotNodesData?.['nsHostType:Bottombar']">
  <ng-container *ngTemplateOutlet="slots?.templates?.['nsHostType:Bottombar'] || null" />
</div>
